import { Button } from '@bambi/component-library/src/components/Button/Button';

import { authService } from './authService';
import { Logo } from 'src/common/Logo';

// Shown when the app cannot load a profile and cannot send the browser to the
// Hosted UI either. Without it the app renders nothing at all, and repeating
// the trip through Cognito would hand the user the login form on a loop.
export function ProfileUnavailableNotice() {
  return (
    <div className="flex h-[100vh] w-[100vw] items-center justify-center">
      <div className="m-16 w-full max-w-lg rounded-lg border border-gray-200 text-center shadow-sm">
        <div className="m-16">
          <div className="mx-auto flex justify-center">
            <Logo />
          </div>
          <h4 className="mt-3 text-lg text-gray-700">
            We can&rsquo;t load your account
          </h4>
          <p className="text-gray-500" data-testid="profile-unavailable-notice">
            Something is stopping us from loading your account right now. Try
            again in a few minutes, and contact support if it keeps happening.
          </p>
          <div className="mt-4">
            <Button
              dataTestId="sign-out-button"
              variant="secondary"
              onClick={authService.signOut}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
